const home = {
  heroAlt: "Professionnels examinant des plans lors d'une rénovation",
  galleryAlt: "Secteur de la construction et de la rénovation",
  install: {
    iosSub: "Télécharger dans l'",
    androidSub: "Disponible sur",
    iosTitle: "Installer sur iPhone/iPad",
    iosDesc: "Ouvrez cette page dans Safari, touchez Partager puis « Sur l'écran d'accueil ».",
    androidTitle: "Installer l'application",
    androidDesc: "Ouvrez le menu du navigateur et choisissez « Installer l'application » / « Ajouter à l'écran d'accueil ».",
  },
  apps: {
    nuvliTitle: "Application mobile NuvliPro",
    nuvliDesc: "Devis, factures, chantiers, dépenses et suivi du temps de travail sur votre mobile.",
    nuvliInstall: "Télécharger NuvliPro",
    nuvliNote: "Installation directe (PWA) · fonctionne sur Android et iPhone, sans occuper d'espace.",
    workerTitle: "Application mobile Pointage GPS",
    workerDesc: "Pour les employés : pointage d'entrée/sortie avec GPS et connexion par code d'accès.",
    workerInstall: "Télécharger Pointage GPS",
    workerNote: "Pour les ouvriers · après l'installation, ouvrez l'application et connectez-vous avec votre code d'accès.",
    workerCta: "Ouvrir l'application employé",
    qrTitle: "Contrôle horaire avec GPS",
    qrSubtitle: "Un pointage simple et sûr pour votre équipe",
    qrText: "Téléchargez-la gratuitement sur notre site",
    qrInstall: "Installer sur le mobile",
    qrAvailable: "Disponible pour Android et iPhone",
  },
  login: {
    title: "Se connecter", email: "E-mail", password: "Mot de passe", emailPh: "vous@email.com", submit: "Se connecter",
    forgot: "Mot de passe oublié ?", register: "Inscription gratuite", welcome: "Bienvenue", error: "Échec de la connexion",
  },
  features: {
    badge: "Fonctionnalités",
    title: "Tout ce qu'il vous faut pour gérer votre entreprise",
    items: [
      { t: "Facturation", d: "Factures avec numérotation automatique, TVA et retenues, statuts et téléchargement en PDF professionnel." },
      { t: "Devis", d: "Devis par chapitres et postes détaillés ; transformez-les en facture en un clic." },
      { t: "Suivi des dépenses", d: "Enregistrez matériaux, main-d'œuvre et fournitures ; suivez les dépenses par chantier et par catégorie." },
      { t: "Paiements partiels", d: "Enregistrez les acomptes, suivez le solde restant dû et envoyez les reçus automatiquement." },
      { t: "Rapports trimestriels", d: "TVA et impôt sur le revenu par trimestre, prêts pour votre comptable et exportables en PDF et Excel." },
      { t: "Gestion des clients", d: "Fiche complète de chaque client, historique des documents et détection des impayés." },
    ],
  },
  pricing: {
    badge: "Formules et tarifs",
    title: "Choisissez la formule la mieux adaptée à votre entreprise",
    subtitle: "Commencez gratuitement, sans date de fin. Passez à une formule supérieure quand vous en avez besoin : sans engagement, résiliez quand vous voulez.",
    freeCta: "Créer un compte gratuit",
    labels: { gratuito: "Formule Gratuite", trimestral: "Formule Trimestrielle", anual: "Formule Annuelle" },
    perMonth: "{{amount}}/mois",
    approx: "≈ {{amount}}/mois",
    periodo: { gratuito: "Sans date de fin", trimestral: "{{total}} tous les 3 mois", anual: "{{total}} par an" },
    nota: { gratuito: "Pour démarrer sans payer", trimestral: "Sans limites, paiement tous les 3 mois", anual: "Un seul paiement par an" },
    badges: { trimestral: "La plus choisie" },
    save: "Vous économisez {{amount}}/an",
    features: {
      gratuito: ["Jusqu'à 8 clients", "Jusqu'à 8 devis", "Facturation et paiements partiels pour vos 8 clients", "Dépenses et trimestriel : les 2 derniers trimestres", "2 projets de chantier", "Pointage avec employés illimités"],
      trimestral: ["Clients, devis et chantiers illimités", "Historique complet des dépenses et trimestres", "IA, VeriFactu et rapprochement bancaire", "Rappels par e-mail et WhatsApp", "Export pour votre comptable"],
      anual: ["Tout le contenu de la formule Trimestrielle", "Documents et logo personnalisés", "Alertes automatiques programmées", "Assistance prioritaire"],
    },
    payCard: "Payer par carte",
    payNote: "Carte : renouvellement automatique, résiliable à tout moment",
    footnote: "Prix hors TVA · Paiement par carte · Paiement sécurisé géré par Stripe",
    approxNote: "Équivalent approximatif en {{currency}} au taux de change du jour. Le montant exact est indiqué sur la page de paiement.",
    payError: "Impossible de lancer le paiement",
  },
  trust: {
    title: "Des professionnels qui font déjà confiance à NuvliPro",
    subtitle: "Avis réels d'entreprises du secteur de la construction et de la rénovation.",
    testimonials: [
      { cargo: "Directeur général", empresa: "Constructora MendozaBuild S.A.", texto: "Pendant plus de dix ans, nous avons travaillé avec Excel et des systèmes qui ne communiquaient pas entre eux. Avec NuvliPro, nous avons réuni toutes les informations de nos 8 projets et réduit de 60 % le temps consacré à l'administration. Les rapports de rentabilité par projet sont désormais précis et je décide avec des données réelles, pas à l'intuition." },
      { cargo: "Directrice de projets", empresa: "Grupo Constructor Rojas & Asociados", texto: "Nous sommes passés de 3 à 12 projets actifs et notre système manuel s'est effondré. Avec NuvliPro, nous avons grandi sans doubler le personnel administratif : traçabilité complète de chaque matériau, suivi des sous-traitants en temps réel et 75 % de documentation finale en moins. Nos clients reçoivent des rapports qui inspirent confiance." },
      { cargo: "Artisan indépendant", empresa: "18 ans dans le secteur", texto: "Mes chantiers devenaient de plus en plus complexes et de moins en moins rentables, et les coûts m'échappaient sans que je sache où. Avec NuvliPro, j'ai repéré les fuites financières, regroupé mes fournisseurs et réduit mes frais généraux de 22 % sans sacrifier la qualité. Aujourd'hui, je fais des devis plus détaillés en moins de temps et je décroche plus de projets." },
    ],
    seals: [
      { t: "Conforme au RGPD", d: "Données protégées" },
      { t: "Chiffrement SSL", d: "Connexion sécurisée" },
      { t: "Paiements avec Stripe", d: "Encaissements protégés" },
      { t: "Assistance en espagnol", d: "Quand vous en avez besoin" },
    ],
  },
  demo: {
    badge: "Vidéo de démonstration",
    title: "Découvrez NuvliPro en 2 minutes",
    subtitle: "Voyez comment créer un devis, le transformer en facture et suivre vos encaissements et dépenses.",
    unsupported: "Votre navigateur ne prend pas en charge la lecture vidéo.",
    soon: "Vidéo de démonstration bientôt disponible",
  },
  faq: {
    badge: "Questions fréquentes",
    title: "Nous répondons à vos questions",
    items: [
      { q: "Faut-il des connaissances en comptabilité pour utiliser NuvliPro ?", a: "Non. NuvliPro est conçu pour les indépendants et les petites entreprises : vous créez devis et factures en remplissant des champs clairs, et l'application calcule automatiquement la TVA, les retenues et les totaux." },
      { q: "Puis-je l'essayer gratuitement ?", a: "Oui. La formule Gratuite n'expire pas et ne demande aucune carte : jusqu'à 8 clients, 8 devis, 8 factures et 1 projet de chantier actif. Quand vous avez besoin de plus, passez à une formule payante." },
      { q: "Les données de mes clients sont-elles en sécurité ?", a: "Oui. Nous chiffrons la connexion (SSL), nous respectons le RGPD et les paiements sont gérés en toute sécurité par Stripe. Nous ne partageons jamais vos données." },
      { q: "Puis-je personnaliser mes factures et devis avec mon logo ?", a: "Oui. Depuis votre Espace personnel, vous pouvez importer le logo de votre entreprise et choisir le design du document pour qu'il reflète votre marque." },
      { q: "NuvliPro sert-il au suivi trimestriel des impôts ?", a: "Oui. Il génère automatiquement le récapitulatif de la TVA collectée/déductible et de l'impôt sur le revenu par trimestre, exportable en PDF et Excel pour votre comptable." },
      { q: "Puis-je résilier quand je veux ?", a: "Bien sûr. Il n'y a aucun engagement : vous pouvez changer ou résilier votre formule à tout moment depuis votre compte." },
    ],
  },
  contact: {
    badge: "Contact",
    title: "On en parle ?",
    subtitle: "Dites-nous ce dont vous avez besoin et nous vous répondrons dès que possible. Nous sommes là pour vous aider à tirer le meilleur parti de NuvliPro.",
    support: "Service client",
    supportNote: "Assistance en espagnol · réponse sous 24-48 h",
    name: "Nom", namePh: "Votre nom", email: "E-mail", emailPh: "vous@email.com",
    message: "Message", messagePh: "Comment pouvons-nous vous aider ?", send: "Envoyer le message",
    sent: "Message envoyé ! Nous vous répondrons bientôt.", error: "Le message n'a pas pu être envoyé",
  },
  cta: {
    title: "Toute votre entreprise, au même endroit",
    items: ["Clients", "Devis", "Facturation", "Paiements partiels", "Dépenses", "Trimestriel", "Impayés", "WhatsApp"],
    button: "Créer mon compte gratuit",
  },
  footer: "Gestion complète pour les professionnels de la construction et de la rénovation",
};
export default home;
